import { createAction } from '@reduxjs/toolkit';

export const CONTACTS_FILTERED_BY_ACTION_TYPE = 'saga/contactsFilteredBy';
export const contactsFilteredByAction = createAction(CONTACTS_FILTERED_BY_ACTION_TYPE);
